import { ReactComponent as CancelIcon } from "assets/icons/cancel.svg";
import { ReactComponent as ChevronDownIcon } from "assets/icons/chevron-down.svg";
import { classNames } from "helpers/ClassNameHelper";
import React, { CSSProperties, useContext } from "react";
import { AccessibilityContext } from "views/AccessibilityContext";

interface Props {
    text?: string;
    isActive: boolean;
    showDropdown: boolean;
    isButton?: boolean;
    className?: string;
    style?: CSSProperties;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onClear?: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

export const Filter: React.FC<Props> = ({
    children,
    text,
    isActive,
    showDropdown,
    isButton,
    className,
    style,
    onClear,
    onClick,
}) => {
    const { lowVision } = useContext(AccessibilityContext);

    return (
        <div className={classNames("filter-container", lowVision && "low-vision")}>
            <button
                onClick={onClick}
                className={classNames(
                    "filter",
                    "filter-base",
                    className,
                    isActive && "filter-active",
                    lowVision && "low-vision"
                )}
            >
                <span className="filter-content">
                    {text}
                    {!isButton && <ChevronDownIcon width={16} height={16} />}
                    {isActive && <CancelIcon onClick={onClear} />}
                </span>
            </button>

            <div
                className={classNames(
                    "filter-dropdown",
                    showDropdown && "filter-dropdown-active",
                    lowVision && "low-vision-filter-dropdown"
                )}
            >
                {children}
            </div>
        </div>
    );
};
